import { render, staticRenderFns } from "./ClientDraft.vue?vue&type=template&id=cc426566&scoped=true&"
import script from "./ClientDraft.vue?vue&type=script&lang=js&"
export * from "./ClientDraft.vue?vue&type=script&lang=js&"
import style0 from "./ClientDraft.vue?vue&type=style&index=0&id=cc426566&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc426566",
  null
  
)

export default component.exports